import Vue from 'vue';
import VueRotuer from 'vue-router';
import { mapGetters } from 'vuex';
import routes from './routes';
import App from './views/App';
import vuetify from './libs/vuetify';
import i18n from './libs/i18n';
import './libs/vee-validate';
import store from './store';
import Lockr from 'lockr';


import DatetimePicker from 'vuetify-datetime-picker';
import 'vuetify-datetime-picker/src/stylus/main.styl';
Vue.use(DatetimePicker);

import { setApiToken, catchUnauthorized } from './api/modules/core';

Vue.use(VueRotuer);
const router = new VueRotuer({
  mode: 'history',
  routes,
});

catchUnauthorized(() => {
  store.dispatch('logout')
});

router.beforeEach(async (to, from, next) => {
  let auth = store.getters.auth;
  if (!auth) {
    let token = Lockr.get('token');
    if (token) {
      setApiToken(token);
      auth = await store.dispatch('me');
    }
  }

  const allowGuest = to.matched.some(record => record.meta.guest);
  return (auth || allowGuest) ? next() : next({
    name: 'login',
    query: {
      redirect: to.fullPath
    }
  });
});

i18n.locale = Lockr.get('locale', 'zh-tw');

new Vue({
  el: '#app',
  components: {
    App,
  },
  i18n,
  vuetify,
  router,
  store,
  computed: {
    ...mapGetters(['auth']),
  },
  watch: {
    '$i18n.locale'(locale) {
      Lockr.set('locale', locale);
    },

    auth(auth) {
      if (!auth) {
        this.$router.push({
          name: 'login'
        });
      }
    }
  },
});
